(() => {
  const initialise = (root) => {
    if (root.dataset.productNordfreskReady === 'true') return;
    root.dataset.productNordfreskReady = 'true';

    const form = root.querySelector('[data-product-form]');
    const quantity = root.querySelector('[data-product-quantity]');
    const submit = root.querySelector('[data-product-atc]');
    const variant = root.querySelector('[data-product-variant]');
    const summaryName = root.querySelector('[data-product-summary-name]');
    const summaryPrices = root.querySelectorAll('[data-product-summary-price]');

    root.querySelectorAll('[data-ships-by]').forEach((element) => {
      const firstDay = Math.max(1, Number(element.dataset.days) || 1);
      const lastDay = Math.max(firstDay, Number(element.dataset.endDays) || 2);
      const start = new Date();
      const end = new Date(start);
      start.setDate(start.getDate() + firstDay);
      end.setDate(end.getDate() + lastDay);
      const locale = document.documentElement.lang || 'en';
      const format = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
      const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
      const endText = sameMonth ? new Intl.DateTimeFormat(locale, { day: 'numeric' }).format(end) : format.format(end);
      element.textContent = firstDay === lastDay ? format.format(start) : `${format.format(start)} - ${endText}`;
    });
    root.querySelectorAll('[data-sale-countdown]').forEach((element) => {
      if (element.dataset.source === 'announcement') {
        const announcement = document.querySelector('[data-nordfresk-sale-timer]');
        if (!announcement) return;
        const sync = () => {
          const parts = ['hours', 'minutes', 'seconds'].map(unit => announcement.querySelector(`[data-nordfresk-sale-${unit}]`)?.textContent.trim());
          if (parts.every(value => /^\d+$/.test(value || ''))) {
            element.querySelector('time').textContent = parts.join(' : ');
            element.hidden = false;
          }
        };
        sync();
        const observer = new MutationObserver(() => {
          if (!root.isConnected) { observer.disconnect(); return; }
          sync();
        });
        observer.observe(announcement, { subtree: true, childList: true, characterData: true });
        return;
      }
      const end = Date.parse(element.dataset.end || '');
      if (!Number.isFinite(end)) return;
      const tick = () => {
        const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        element.hidden = seconds === 0;
        element.querySelector('time').textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(value => String(value).padStart(2, '0')).join(' : ');
      };
      tick();
      const timer = window.setInterval(() => {
        if (!root.isConnected || Date.now() >= end) { tick(); window.clearInterval(timer); return; }
        tick();
      }, 1000);
    });
    const updateStock = bundle => {
      if (!bundle) return;
      root.querySelectorAll('[data-stock-copy]').forEach(element => {
        element.textContent = element.dataset.template.replace('[savings]', bundle.dataset.savings || '');
      });
    };
    updateStock(root.querySelector('[data-product-bundle].is-selected'));

    const carousel = root.querySelector('[data-product-carousel]');
    const thumbs = [...root.querySelectorAll('[data-product-thumb]')];
    if (carousel) {
      const slides = [...carousel.querySelectorAll('.pmh__mobile-slide')];
      let current = 0;
      const sync = (index) => {
        current = index;
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', String(i === index));
        });
        const thumb = thumbs[index];
        if (thumb) {
          const rail = thumb.parentElement;
          const target = thumb.offsetLeft - rail.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2;
          rail.scrollTo({ left: target, behavior: 'auto' });
        }
      };
      const select = (index) => {
        const next = Math.max(0, Math.min(index, slides.length - 1));
        sync(next);
        carousel.scrollTo({ left: slides[next].offsetLeft - slides[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
      carousel.addEventListener('scroll', () => {
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(carousel.scrollLeft / carousel.clientWidth)));
        if (index !== current) sync(index);
      }, { passive: true });
      carousel.addEventListener('keydown', (event) => {
        if (event.target !== carousel || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        select(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      window.addEventListener('resize', () => {
        if (carousel.clientWidth) carousel.scrollTo({ left: current * carousel.clientWidth, behavior: 'instant' });
      }, { passive: true });
      sync(0);
    }

    root.querySelectorAll('[data-product-bundle]').forEach((bundle) => {
      bundle.addEventListener('click', () => {
        updateStock(bundle);
        root.querySelectorAll('[data-product-bundle]').forEach((item) => {
          item.classList.toggle('is-selected', item === bundle);
          item.setAttribute('aria-pressed', String(item === bundle));
        });
        if (quantity) quantity.value = bundle.dataset.quantity || '1';
        root.querySelectorAll('[data-product-gift]').forEach((gift) => {
          gift.hidden = Number(bundle.dataset.quantity || 1) < Number(gift.dataset.minQuantity || 1);
        });
        if (summaryName) summaryName.textContent = bundle.dataset.name || '';
        if (bundle.dataset.price) {
          summaryPrices.forEach((element) => {
            element.textContent = bundle.dataset.price;
          });
        }
        root.querySelectorAll('[data-product-offer-compare], [data-product-summary-compare]').forEach((element) => { element.textContent = bundle.dataset.compare || ''; });
        root.querySelectorAll('[data-product-offer-price]').forEach((element) => { element.textContent = bundle.dataset.unitPrice || ''; });
        root.querySelectorAll('[data-product-offer-suffix]').forEach((element) => { element.textContent = bundle.dataset.offerSuffix || ''; });
      });
    });

    root.querySelector('[data-product-bundle].is-selected')?.click();

    variant?.addEventListener('change', () => {
      // Re-render all market-aware values together when changing variants.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.value);
      window.location.assign(url);
    });

    root.querySelectorAll('[data-parity-video]').forEach((container) => {
      const video = container.querySelector('video');
      const toggle = container.querySelector('[data-video-toggle]');
      if (!video || !toggle) return;
      const sync = () => {
        container.classList.toggle('is-playing', !video.paused);
        toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      };
      toggle.addEventListener('click', async () => {
        if (!video.paused) video.pause();
        else {
          try { await video.play(); }
          catch { video.controls = true; toggle.hidden = true; }
        }
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
    });

    root.querySelectorAll('[data-product-submit]').forEach((button) => {
      button.addEventListener('click', () => {
        if (form && submit) form.requestSubmit(submit);
      });
    });

    const stickyBars = root.querySelectorAll('[data-product-sticky]');
    const updateSticky = () => {
      const firstBundle = root.querySelector('[data-product-bundle]');
      if (!firstBundle) return;
      const bounds = firstBundle.getBoundingClientRect();
      const visible = bounds.bottom < 0;
      stickyBars.forEach((bar) => bar.classList.toggle('is-visible', visible));
    };

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  };

  document.querySelectorAll('[data-product-nordfresk]').forEach(initialise);
  const initialiseKit = (root) => {
    if (root.dataset.kitReady) return;
    root.dataset.kitReady = 'true';
    root.querySelectorAll('[data-kit-target]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-kit-target]').forEach((item) => {
          const active = item.dataset.kitTarget === button.dataset.kitTarget;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        root.querySelectorAll('[data-kit-row]').forEach((item) => item.classList.toggle('is-active', item.dataset.kitRow === button.dataset.kitTarget));
      });
    });
  };
  document.querySelectorAll('[data-parity-kit]').forEach(initialiseKit);
  const initialiseReferenceValues = (root) => {
    root.querySelectorAll('[data-reference-money]').forEach((element) => {
      const base = element.dataset.baseCurrency;
      const currency = element.dataset.currency || window.Shopify?.currency?.active;
      const rate = base === currency ? 1 : Number(window.Shopify?.currency?.rate);
      const amount = Number(element.dataset.referenceMoney);
      if (!currency || !Number.isFinite(rate) || rate <= 0 || !Number.isFinite(amount)) return;
      if (base !== currency) {
        try {
          element.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, ...(element.dataset.trimZeros === 'true' ? { minimumFractionDigits: 0 } : {}) }).format(amount * rate / 100);
        } catch { return; }
      }
      element.hidden = false;
    });
  };
  initialiseReferenceValues(document);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-product-nordfresk]');
    if (root) initialise(root);
    event.target.querySelectorAll('[data-parity-kit]').forEach(initialiseKit);
    initialiseReferenceValues(event.target);
  });
})();

// Native details keep navigation usable before JavaScript loads.
document.addEventListener('click', (event) => {
  const menus = document.querySelectorAll('.npnav__group[open], .npnav-mobile[open]');
  menus.forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.npnav__group[open], .npnav-mobile[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});

document.addEventListener('click', (event) => {
  const back = event.target.closest('[data-parity-menu-back]');
  if (back) { const group = back.closest('details'); group.open = false; group.querySelector('summary')?.focus(); }
  const close = event.target.closest('[data-parity-menu-close]');
  if (close) { const drawer = close.closest('.npnav-mobile'); drawer.open = false; drawer.querySelector('summary')?.focus(); }
});
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-parity-country]')) event.target.form?.requestSubmit();
});
document.addEventListener('toggle', (event) => {
  const group = event.target;
  if (!group.matches?.('.npnav__group') || !group.open) return;
  group.parentElement.querySelectorAll('.npnav__group').forEach((other) => { if (other !== group) other.open = false; });
}, true);
